import React from 'react';
export const StateIcon = () => (
  <svg
    width="6"
    height="14"
    viewBox="0 0 6 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00163 0.333496H1.00163C0.633438 0.333496 0.334961 0.631973 0.334961 1.00016V5.00016C0.334961 5.36835 0.633438 5.66683 1.00163 5.66683H2.50163V10.3333L1.84294 10.3335C1.38294 10.3335 1.33496 10.421 1.33496 10.789V13.1982C1.33496 13.5662 1.38294 13.6668 1.84294 13.6668L4.10593 13.6663C4.56593 13.6663 4.66829 13.5662 4.66829 13.1982V10.789C4.66829 10.421 4.56593 10.333 4.10593 10.333L3.50163 10.3331V5.66683H5.00163C5.36982 5.66683 5.66829 5.36835 5.66829 5.00016V1.00016C5.66829 0.631973 5.36982 0.333496 5.00163 0.333496ZM1.33496 1.3335H4.71274V4.66683H1.33496V1.3335Z"
      fill="#111111"
    />
  </svg>
);
